export default __webpack_public_path__ + "static/media/Stalker's Boots of Charred Earth.1085c847.jpg";